import { ChevronRight } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import AvatarWithLoader from 'components/avatar-with-loader'
import { PostControls } from 'components/billboard/index'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as NivosPostOperations,
  operations as nivosPostOperations
} from 'states/dux/nivos-post/operations'
import { Payload as NivosPostPayload } from 'states/dux/nivos-post/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import {
  get,
  mapOperationsToDispatchProps,
  objectifyDateStringFields
} from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
  nivosPost: NivosPostPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
    nivosPost: NivosPostOperations
  }
}

type AppProps = StateProps & DispatchProps

const PostsFC: React.FC<any> = (props: AppProps) => {
  const { nivosPost, operations, theme } = props
  const navigate = useNavigate()

  React.useEffect(() => {
    // Fetch nivos posts
    if (nivosPost.data.length < 1) {
      operations.nivosPost.loading(true)
      void get('/post/').then(data => {
        const parsedData = data.map((item: any) =>
          objectifyDateStringFields(item)
        )
        operations.nivosPost.set(parsedData)
        operations.nivosPost.loading(false)
      })
    }
  }, [])

  return (
    <Box display={'flex'} flexDirection={'column'} padding={4}>
      <Box display={'flex'} justifyContent={'center'} paddingY={6}>
        <Typography variant={'h4'} padding={2} flexGrow={1}>
          NEW POSTS
        </Typography>
        <PostControls />
      </Box>
      <Box display={'flex'} width={1} padding={2}>
        <Box
          width={1}
          border={2}
          borderColor={'#d4d2d2'}
          borderRadius={4}
          minHeight={400}
        >
          {nivosPost.data.length === 0 && !nivosPost.loading && (
            <Box
              height={1}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <Typography variant={'h4'}>
                <i>=Empty</i>
              </Typography>
            </Box>
          )}
          {nivosPost.data.map((postData, index) => (
            <Box
              key={index}
              display={'flex'}
              padding={2}
              borderBottom={1}
              borderColor={'#d4d2d2'}
              alignItems={'center'}
              bgcolor={index % 2 === 0 ? 'initial' : theme.quaternaryColor}
              sx={{ cursor: 'pointer' }}
              onClick={() => navigate(`posts/${postData.id}`)}
            >
              <Typography
                minWidth={300}
                maxWidth={300}
                fontSize={20}
                paddingLeft={2}
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                {postData.title}
              </Typography>
              <Typography minWidth={155}>
                <small>{postData.createdAt.toUTCString().slice(0, 16)}</small>
              </Typography>
              <AvatarWithLoader
                src={
                  postData.createdBy.image !== undefined
                    ? postData.createdBy.image.url
                    : ''
                }
                avatarProps={{
                  sx: {
                    height: 40,
                    width: 40,
                    margin: 'auto'
                  }
                }}
                containerProps={{
                  width: 50,
                  height: 50,
                  marginRight: 5
                }}
              />
              <Typography
                flexGrow={1}
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                <small>{postData.content.replace(/\n/g, ' ')}</small>
              </Typography>
              <Box>
                <IconButton>
                  <ChevronRight />
                </IconButton>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <Typography variant={'h4'} padding={2} paddingY={6}>
        SAVED POSTS
      </Typography>
      <Box display={'flex'} width={1} padding={2}>
        <Box
          width={1}
          border={2}
          borderColor={'#d4d2d2'}
          borderRadius={4}
          minHeight={400}
        >
          {nivosPost.data.filter(i => i.saved).length === 0 &&
            !nivosPost.loading && (
              <Box
                height={1}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
              >
                <Typography variant={'h4'}>
                  <i>=Empty</i>
                </Typography>
              </Box>
          )}
          {nivosPost.data
            .filter(i => i.saved)
            .map((postData, index) => (
              <Box
                key={index}
                display={'flex'}
                padding={2}
                borderBottom={1}
                borderColor={'#d4d2d2'}
                alignItems={'center'}
                bgcolor={index % 2 === 0 ? 'initial' : theme.quaternaryColor}
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate(`posts/${postData.id}`)}
              >
                <Typography
                  minWidth={300}
                  maxWidth={300}
                  fontSize={20}
                  paddingLeft={2}
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {postData.title}
                </Typography>
                <Typography minWidth={155}>
                  <small>{postData.createdAt.toUTCString().slice(0, 16)}</small>
                </Typography>
                <AvatarWithLoader
                  src={
                    postData.createdBy.image !== undefined
                      ? postData.createdBy.image.url
                      : ''
                  }
                  avatarProps={{
                    sx: {
                      height: 40,
                      width: 40,
                      margin: 'auto'
                    }
                  }}
                  containerProps={{
                    width: 50,
                    height: 50,
                    marginRight: 5
                  }}
                />
                <Typography
                  flexGrow={1}
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  <small>{postData.content.replace(/\n/g, ' ')}</small>
                </Typography>
                <Box>
                  <IconButton>
                    <ChevronRight />
                  </IconButton>
                </Box>
              </Box>
            ))}
        </Box>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user,
    nivosPost: state.nivosPost
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations,
  nivosPost: nivosPostOperations
})

const Posts = connect(mapStateToProps, mapDispatchToProps)(PostsFC)

export default Posts
